import { Component } from "@angular/core";
import { TaxCard } from "@salaxy/core";
import { SalaxyContext } from "../../../services/index";

/* tslint:disable */
/* TODO: Waiting for rewrite / final implementation */

@Component({
    selector: "salaxy-tax-card-list",
    template: ``,
})

export class NgTaxcardListComponent {

    public taxCardList: TaxCard[];
    private groupBy = "year";

    constructor(protected context: SalaxyContext) {
    }

    /** Initializes the component */
    public ngOnInit() {
        this.taxCardList = this.getTaxCardList();
    }

    public getTaxCardList() {
        return this.context.taxCards.getList();
    }

    public delete(id: string) {
        this.context.taxCards.delete(id);
    }

    /**
     * List grouped based on groupBy value
     */
    public get groupedList() {
        const sortDescending =  true;
        const groupedObj = this.taxCardList.reduce((prev, cur) => {
            let key = "Unknown grouping: " + (this.groupBy || "[null]");

            // TODO: Move the getting of a date to a generic helper
            const date: any = cur.card.forYear || cur.updatedAt || cur.createdAt || "0000";
            if (date.getFullYear) {
                key = "" + date.getFullYear();
            } else {
                key = ("" + date).substr(0, 4);
            }

            if (!prev[key]) {
                prev[key] = [cur];
            } else {
                prev[key].push(cur);
            }
            return prev;
        }, {});

        return Object.keys(groupedObj)
            .map((key) => ({ key, value: groupedObj[key] }))
            .sort((n1, n2) => {
                if (n1.key > n2.key) {
                    return sortDescending ? -1 : 1;
                }
                if (n1.key < n2.key) {
                    return sortDescending ? 1 : -1;
                }
                return 0;
            });
    }

}
